module.exports = __webpack_public_path__ + "img/Loading_akkodis_logo_4.dc798ea1.svg";